import { render, staticRenderFns } from "./ManageOrdersMaterials.vue?vue&type=template&id=7a98a1f9&scoped=true"
import script from "./ManageOrdersMaterials.vue?vue&type=script&lang=js"
export * from "./ManageOrdersMaterials.vue?vue&type=script&lang=js"
import style0 from "./ManageOrdersMaterials.vue?vue&type=style&index=0&id=7a98a1f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a98a1f9",
  null
  
)

export default component.exports